import { useAllLocationsSelectedDealerId, usePermanentLocations } from "components/DealersAndLocationsDropdown/hooks";

import type { User } from "models";

export const useAllSelectedLocations = (user?: User) => {
  const { allLocationsSelectedDealerId } = useAllLocationsSelectedDealerId();
  const { locations } = usePermanentLocations();

  if (!user) return [];
  if (user.my_locations?.length) {
    return locations.filter(loc => loc.dealer_id === allLocationsSelectedDealerId).filter(loc => user.my_locations?.includes(loc.id));
  }
  if (user.location_ids?.length) {
    return locations.filter(loc => loc.dealer_id === allLocationsSelectedDealerId).filter(loc => user.location_ids?.includes(loc.id));
  }

  return locations.filter(loc => loc.dealer_id === user.dealer_id).filter(loc => loc.active);
};
